import { render, staticRenderFns } from "./product-stock-list.vue?vue&type=template&id=40fe9884&scoped=true&"
import script from "./product-stock-list.vue?vue&type=script&lang=js&"
export * from "./product-stock-list.vue?vue&type=script&lang=js&"
import style0 from "./product-stock-list.vue?vue&type=style&index=0&id=40fe9884&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fe9884",
  null
  
)

export default component.exports